export interface IKeyedInDirection {
    id: string;
    name: string;
    count: number;
    dropdown: any[];
}

export class KeyedInDirection implements IKeyedInDirection {
    id: string;
    name: string;
    count: number;

    constructor(id: string, name: string, count: number) {
        this.id = id;
        this.name = name;
        this.count = count;

        this.dropdown = [{
            value: this.id,
            label: this.name
        }];

    }
    dropdown: any;
}